import { useState, useContext } from "react";
import { getUno } from "../../api/apis";
import { DataContext } from "../../contextData/contextData";

export const useCambioInstalacion = () => {
  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [instalaciones, setInstalaciones] = useState([]);
  const { uno } = useContext(DataContext);

  const getUnidadesNegocio = async () => {
    const resp = await getUno('getcategoriasinstalaciones', null, null);
    if ([200].includes(resp.status)) {
      setUnidadesNegocio(resp.data.data);
    }
  }

  const getInstalaciones = async categoria => {
    const resp = await getUno('getinstalacionesporcategoria', { "categoria": categoria }, null);
    if ([200].includes(resp.status)) {
      setInstalaciones(resp.data.data.data);
    }
  }

  return {
    getUnidadesNegocio, unidadesNegocio,
    getInstalaciones, instalaciones
  }
}
